import { v4 as uuidv4 } from 'uuid'

export const tabItems = {
  config: {
    is_enabled: true,
    max_item: 4,
  },
  routes: [
    {
      tab_name: 'Pending Surveys',
      application_id: `${uuidv4()}`,
      is_enabled: true,
      route_name: 'todos',
    },
    {
      tab_name: 'Recently Completed',
      application_id: `${uuidv4()}`,
      is_enabled: true,
      route_name: 'recent',
    },
  ],
}
